import { render, staticRenderFns } from "./ItemFormProduct.vue?vue&type=template&id=2c38d57e&scoped=true&"
import script from "./ItemFormProduct.vue?vue&type=script&lang=js&"
export * from "./ItemFormProduct.vue?vue&type=script&lang=js&"
import style0 from "./ItemFormProduct.vue?vue&type=style&index=0&id=2c38d57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38d57e",
  null
  
)

export default component.exports